export enum CookieName {
  AuthToken = 'authToken',
  AuthRedirectUrl = 'authRedirectUrl',
  Test = 'testCookie',
  LandingUrl = 'landingUrl',
  AppGuid = 'appGuid',
  UserId = 'userId',
  ReferrerUrl = 'referrerUrl',
}
